<template>
  <div class="classSignRecord">
    <div class="title">
      <h3>签到记录(任课老师)</h3>
    </div>
    <div class="searchBox">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="上课时间">
          <el-date-picker
            v-model="searchForm.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="searchForm.gradeId" placeholder="请选择">
            <el-option
              v-for="item in gradeList"
              :key="item.gradeId"
              :label="item.gradeName"
              :value="item.gradeId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <el-input v-model="searchForm.className"></el-input>
        </el-form-item>
        <el-form-item label="课程名称">
          <el-input v-model="searchForm.courseName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchBtn">查询</el-button>
          <el-button type="primary" @click="reSet">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <div class="content">
        <el-table :data="tableData" style="width: 100%"  v-loading="loading">
          <el-table-column type="index" label="序号" width="80" align="center">
          </el-table-column>
          <el-table-column prop="name" label="课程名称" align="center">
          </el-table-column>
          <el-table-column prop="classrooms" label="上课教室" align="center">
          </el-table-column>
          <el-table-column prop="knob" label="课程节数" align="center">
          </el-table-column>
          <el-table-column prop="teachers" label="授课老师" align="center">
          </el-table-column>
          <el-table-column prop="timeRange" label="上课时间" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.date}} {{scope.row.timeRange}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="gradeName" label="年级" align="center">
          </el-table-column>
          <el-table-column prop="classname" label="班级" align="center">
          </el-table-column>
          <el-table-column prop="status" label="签到状态" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.status | statusFormat}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="attendanceTime" label="签到时间" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="row">
              <el-button size="mini" type="primary" plain @click="detail(row.row)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          @size-change="changeSize"
          @current-change="changePage"
          :current-page.sync="paramSearch.current"
          :page-sizes="pageSizes"
          :page-size.sync="paramSearch.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="签到详情"
      :visible.sync="visible"
      v-if="visible"
      width="80%"
      :append-to-body="true"
      >
      <RecordDetail :info="info"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import RecordDetail from "./classSignRecordDetail.vue";
import { getTeacherAttendance, getGradeNameList } from "@/api/overseasChinese/overseasChinese"
export default {
  components: {
    RecordDetail,
  },
  data() {
    return {
      tableData: [],
      searchForm: {
        time:[],
        gradeId: "",
        className: "",
        courseName: "",
      },
      paramSearch: {
        current: 1,
        size: 20,
      },
      total: 0,
      pageSizes: [20, 50, 100],
      visible: false,
      value1: "",
      treeShow: false,
      loading: false,
      info:"",
      gradeList:[],
    };
  },
  filters: {
    statusFormat: function (value) {
      if(!value) {
          return'缺勤'
        }else if(value == 1) {
          return'正常'
        } else if(value == 2) {
          return'迟到'
        } else if(value == 3) {
          return'早退'
        } else if(value == 4) {
          return'缺勤'
        }
    },
  },
  created() {
  },
  mounted() {
    this.getGradeNameList();
    this.searchBtn()
  },
  methods: {
    //获取年级列表
    getGradeNameList(){
      getGradeNameList().then(res=>{
        this.gradeList = res.data.data;
      })
    },
    //条件筛选
    initPage() {},
    //查询
    searchBtn() {
      this.loading = true;
      const params={
        startTime:this.searchForm.time[0]?this.searchForm.time[0]:"",
        endTime:this.searchForm.time[1]?this.searchForm.time[1]:"",
        gradeId: this.searchForm.gradeId,
        className: this.searchForm.className,
        courseName: this.searchForm.courseName,
        size:this.paramSearch.size,
        current:this.paramSearch.current,
      }
      getTeacherAttendance(params)
      .then(res=>{
        if(res.data.success){
          this.tableData = res.data.data.records;
          this.paramSearch.current = res.data.data.current;
          this.total = res.data.data.total;
          this.loading=false
        }
      }).catch(res=>{
          this.loading=false
      })
    },
    //重置
    reSet() {
      this.searchForm = {
        time:[],
        className: "",
        courseName: "",
        gradeId: "",
      }
      this.paramSearch = {
        current: 1,
        size: 20,
      }
      this.searchBtn()
    },
    //详情
    detail(val) {
      this.info = val
      this.visible = true;
    },
    changeSize(val) {
      this.paramSearch.size = val;
      this.searchBtn()
    },
    changePage(val) {
      this.paramSearch.current = val;
      this.searchBtn()
    },
  },
};
</script>
<style scoped lang="less">
.classSignRecord {
  width: 100%;
  height: 100%;
  .title {
    height: 50px;
  }
  .searchBox {
    height: 50px;
  }
  .table {
    height: calc(100vh - 150px);
    .content {
      height: calc(100vh - 200px);
    }
  }
}
</style>